import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const FavouriteGridConatainer = styled(Grid)`
    color: blue;
    padding: 27px 8px;
    ${media.smalDevice`
        padding: 27px 12px;
    `}
    ${media.mobileDevice`
        display:none;
    `}
`;
export const AccountContainer = styled.span`
    position: absolute;
    right: 3px;
    background: #ffffff;
    color: blue;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    ${media.mobileDevice`
        margin-top:12px;
        display:block;
    `}
`;
export const FavouriteIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 24px;
    height: 24px;
    display: block;
    cursor: pointer;
`;
export const FavoriteIconDesktopContainer = styled.div`
    background: #ffffff;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;

    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
    ${media.smalDevice`
    padding: 13px;
    background: #ffffff;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;

    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
`};
    ${media.mobileDevice`
        display:none;
    `};
`;
export const FavoriteIconMobileContainer = styled.span`
    display: none;
    ${media.mobileDevice`
        background: #ffffff;
        box-shadow: 0px 0px 2px #00000029;
        border: 1px solid #ebebeb;
        border-radius: 6px;
        opacity: 1;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: ${({ marginRight }) => marginRight};
        position: absolute;
        right: 15px;
        top:23px
    `};
`;

export const HeaderGridContainer = styled(Grid)`
    width: 1096px;
    height: 48px;
    padding: 7px 0 0 20px;
    background: #ffffff;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    ${media.smalDevice`
    padding-left: 10px;
`}
    ${media.mobileDevice`
        display:none !important;
    `}
`;
export const HeaderTextContainer = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    letter-spacing: 0px;
    padding-left: 30px;
    color: #3c3c3c;
    opacity: 0.7;
    width: 89px;
    height: 22px;
    ${media.smalDevice`    
        padding-left: 18px;
    `}
`;
export const AccountGridContainer = styled(Grid)`
    width: 1096px;
    min-height: 78px;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 10px;
`;
export const AccountNameGrid = styled(Grid)`
    text-align: left;
    font-size: 15px;
    font-family: AvenirNextWorld Demi;
    letter-spacing: -0.12px;
    color: #1010eb;
    opacity: 1;
    padding: 30px 21px;
    ${media.smalDevice`    
        padding:23px 23px;
        justify-content: space-between;
    `}
    ${media.mobileDevice`    
        padding-bottom:0px;
        position:relative;
    `}
`;
export const AccountNumberDesktopGrid = styled(Grid)`
    text-align: left;
    font-family: AvenirNextWorld Regular;
    font-size: 15px;
    letter-spacing: -0.12px;
    color: #140f4b;
    opacity: 1;
    padding: 30px -1px;
`;
export const AccountNumberMobileGrid = styled(Grid)`
    display: none;
    ${media.mobileDevice`  
    display:flex;
    text-align: left;
    font-family: AvenirNextWorld Regular;
    letter-spacing: -0.12px;
    color: #140f4b;
    opacity: 1;  
        padding:0px 25px;    
    `};
`;
export const CityGrid = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    font-size: 12px;
    letter-spacing: -0.1px;
    color: #140f4b;
    // text-transform: uppercase;
    opacity: 0.6;
    padding: 30px -1px;
`;

export const StyledSortIcon = styled.div`
    width: 18px;
    height: 16px;
    margin: auto;
    margin-right: 8px;
`;
export const DistrictGrid = styled(Grid)`
    padding: 27px 30px;
    ${media.smalDevice`    
        padding: 25px 16px;
    `}
    ${media.mobileDevice`    
        padding:0px 25px !important;
        margin-bottom: 12px !important;
    `}
`;

export const DitrictNameContainer = styled.span`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    font-size: 14px;
    letter-spacing: -0.11px;
    color: #140f4b;
`;
export const TerritoryNameContainer = styled.span`
    text-align: left;
    font-family: AvenirNextWorld Regular;
    font-size: 14px;
    letter-spacing: -0.11px;
    color: #140f4b;
`;
export const MoreItemView = styled.div`
    margin: 2.25px 0px 0px 8px;
    color: #1010eb;
    font-size: 11px;
    font-family: 'AvenirNextWorld Regular';
    cursor: pointer;
`;
export const MoreContainer = styled.p`
    font-family: AvenirNextWorld Regular;
    font-size: 11px;
    letter-spacing: -0.09px;
    color: #1010eb;
    opacity: 1;
    text-align: left;
    cursor: pointer;
`;
export const SortIcon = styled.span`
    margin-left: 10px;
`;

export const AccountDetailsContainer = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    ${media.smalDevice`
        height: 100%;
    `}
    ${media.mobileDevice`
        height: 100vh;
    `}
`;
export const MainSubContainer = styled.div`
    width: 100%;
    height: auto;
    padding-left: 1px;
    ${media.mobileDevice`
        height: auto;
        width:auto;
        margin-top: 0%;
    `}
`;
export const AccountNumberHeader = styled.span`
    ${media.mobileDevice`
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    font-size:14px;
    letter-spacing: -0.11px;
    color: #140F4B;
    opacity: 1;
    `}
`;

export const DesktopView = styled.div`
    display: block;
`;

export const AccountNumberSpan = styled.span`
    ${media.mobileDevice`
     text-align: left;
     font-family: AvenirNextWorld Regular;
     font-size : 15px;
     letter-spacing: -0.12px;
     color: #140F4B;
     opacity: 1;
     margin-left:4px;
    `}
`;
export const AssociatedAccountBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    padding: 0 3px 30px 0;
    box-sizing: border-box;
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    ${media.smalDevice`
    padding-bottom: 80px;
    `}
    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-right: 0;
        margin-top: 15px;
    padding-bottom: 70px;
    `}
`;
export const AccountPaginationWrapper = styled.div`
    position: relative;
    width: 100%;
    bottom: 0;
    margin: 0 auto;
    ${media.smalDevice`
    position: relative;
    `}
    ${media.mobileDevice`
    position: fixed;
    width: 96%;
    `}
    @media only screen and (min-device-width: 768px) and (max-device-width: 820px) and (orientation: portrait) {
        position: relative;
    }
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        background-color:#ffffff;
        box-shadow: 0px -3px 6px #00000014;
        margin-left: -16px;
    `}
`;

export const DesktopViewPagination = styled.div`
    display: block;
    ${media.mediumDevice`
    width: 100%;
    `}
    ${media.smalDevice`
    width: 98%;
    `}
    ${media.mobileDevice`
        display: none;
    `}
`;
export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        padding-top: 10px;
        justify-content: space-between;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      padding ? padding : '1.125rem'
                  }, calc(4*env(safe-area-inset-bottom)))`
                : padding
                ? padding
                : '1.125rem'} 
    `}
`;
export const PaginationContainer = styled.div`
    height: 48px;
    box-shadow: none;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;
    .p-paginator {
        padding: 0.5rem 2rem !important;
    }

    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}

    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none;  
        .p-paginator {
        padding: 0.5rem 3rem !important;
    }  
    `}
  
    ${media.mobileDevice`
    flex-direction:column;
    margin: 10px 0px 0px 0px;
    box-shadow: none;
    border-radius: none;        
`}
`;
